import { render, staticRenderFns } from "./ProductCategories.vue?vue&type=template&id=2ec9b1af&scoped=true"
import script from "./ProductCategories.vue?vue&type=script&lang=js"
export * from "./ProductCategories.vue?vue&type=script&lang=js"
import style0 from "./ProductCategories.vue?vue&type=style&index=0&id=2ec9b1af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec9b1af",
  null
  
)

export default component.exports